include ../../../common/primary/icon/icon.mixin.pug

.fp-video(@click='onClick(url)' data-test='video' :class='{"-wide": wide, "-expand": expand}')
  video
    source(:src='url' type='video/mp4')
  .fp-video--trigger
    +fp-icon('play', {size: 16, color: 'shade-900'})
